import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material'; 
import CloseIcon from '@mui/icons-material/Close';
import { ReportsBuilderContext, ReportBuilderValues } from '../context/ReportsBuilderContext';
import { useContext, useCallback } from 'react'; 
import { theme } from '../../../theme'; 
import { Save01 } from '../../../assets'; 

const GoBackInfo=() => {
  const { t,
    openGoBackDialog,
    handleClose, 
    handleGoBackConfirm,
    blocker,
  } = useContext(ReportsBuilderContext) as ReportBuilderValues;

  const isBlockedByRouter = blocker.state === 'blocked';
  const isOpen = openGoBackDialog || isBlockedByRouter;

  const onClose = useCallback(() => {
    if (isBlockedByRouter) {
      blocker.reset?.();
    }
    handleClose();
  }, [isBlockedByRouter, blocker, handleClose]);

  const onConfirm = useCallback(() => {
    if (isBlockedByRouter) {
      blocker.proceed?.();
    } else {
      handleGoBackConfirm();
    }
  }, [isBlockedByRouter, blocker, handleGoBackConfirm]);

  return (
    <Dialog
      fullWidth
      maxWidth='sm'
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiDialog-container': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar
            sx={{
              backgroundColor: () => theme.palette.warning[100],
              color: () => theme.palette.warning[700],
            }}
          >
            <Save01 color={theme.palette.warning[500]} />
          </Avatar>
        </Box>

        <IconButton
          onClick={handleClose}
          sx={{
            color: (theme) => theme.palette.custom.gray[800],
            mr: '-10px',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Stack>
          <Typography variant='textLG'
            fontWeight={600}> {t('leavePage')}</Typography>
          <Typography color="textSecondary"
            sx={{ mt: 1 , whiteSpace: 'pre-line' }}
            variant="textSM">
            {t('goBackModal')}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ 
        padding: '0px 24px 24px', 
        '&.MuiDialogActions-root': {
          padding: '0px 24px 24px', 
        },
      }}>
        <Stack direction={{ xs: 'column', md: 'row' }}
          gap='12px'
          width='100%'>
          <Button
            fullWidth
            variant="secondary"
            sx={{ fontSize: '16px' }} 
            size="md"
            onClick={onClose}>
            {t('close')}
          </Button>
          <Button
            fullWidth
            variant="primary"
            sx={{ fontSize: '16px' }} 
            size="md"
            onClick={onConfirm}
          >
            {t('confirm')}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog > 
   
  );
};

export default GoBackInfo;